import { render } from "./sound.vue?vue&type=template&id=5c2a527f"
import script from "./sound.vue?vue&type=script&lang=js"
export * from "./sound.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__